import { RiCloseLine, RiAddLine } from 'react-icons/ri';

const TabBar = ({ tabs, activeTabId, onSwitch, onAdd, onClose }) => (
  <div className="flex items-center gap-1 px-2 py-1.5 bg-panel border-b border-border overflow-x-auto shrink-0 window-drag">
    {tabs.map((tab) => (
      <div
        key={tab.id}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm cursor-pointer select-none min-w-0 max-w-[200px] group window-no-drag ${
          tab.id === activeTabId
            ? 'bg-surface/80 text-white border border-border'
            : 'text-textMuted hover:text-white hover:bg-white/5'
        }`}
        onClick={() => onSwitch(tab.id)}
        title={tab.label || 'New Tab'}
      >
        <span
          className={`h-2 w-2 rounded-full shrink-0 ${
            tab.connected ? 'bg-green-400' : 'bg-zinc-500'
          }`}
        />
        <span className="truncate text-sm">{tab.label || 'New Tab'}</span>
        {tabs.length > 1 && (
          <button
            type="button"
            className="ml-auto shrink-0 opacity-0 group-hover:opacity-60 hover:!opacity-100 hover:text-red-300 window-no-drag"
            onClick={(e) => {
              e.stopPropagation();
              onClose(tab.id);
            }}
            title="Close tab"
          >
            <RiCloseLine className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    ))}
    <button
      type="button"
      className="flex h-8 w-8 items-center justify-center rounded-lg text-textMuted hover:text-white hover:bg-white/5 shrink-0 window-no-drag"
      onClick={onAdd}
      title="New tab"
    >
      <RiAddLine className="h-4 w-4" />
    </button>
  </div>
);

export default TabBar;
